<template>
  <div class="card mb-0 shadow">
		<div class="card-body">
			<div class="tab-content">
				<div class="animate__animated animate__fadeIn">
					<div class="row">
						<div class="col-12">
							<h4 class="font-weight-bold">Histórico de Avaliações</h4>
						</div>
						<div class="col-12 mb-3">
							<table
								class="table table-bordered bg-white table-sm"
								v-for="historico in acompanhamento.avaliacoes"
								:key="historico.id"
							>
								<tr>
									<td>Data: <b>{{ historico.data_avaliacao }}</b></td>
								</tr>
								<tr>
									<td v-html="historico.descricao_resultados"></td>
								</tr>
								<tr>
									<td>
										Técnico: <b>{{ historico.nome_tecnico }}</b>
									</td>
								</tr>
								<tr><td>Tempo em acompanhamento: <b>{{ historico.tempo_em_acompanhamento }}</b></td></tr>
								<tr>
									<td>Oferta de assistência social: <b>{{ historico.foram_disponibilizada_todas_ofertas }}</b> </td>
								</tr>
								<tr>
									<td>Atendimento efetivo: <b>{{ historico.atendimento_efetivo_encaminhamentos }}</b></td>
								</tr>
								<tr>
									<td>Contribuiu para superação: <b>{{ historico.reconhecimento_familia }}</b></td>
								</tr>
								<tr>
									<td>Houve um agravamento/piora em relação à situação inicial da família/indivíduo: <b>{{ historico.classificacao_resultados_um }}</b></td>
								</tr>
								<tr>
									<td>A situação atual é equivalente à situação inicial, sem avanços identificáveis: <b>{{ historico.classificacao_resultados_dois }}</b></td>
								</tr>
								<tr>
									<td>Houve avanço/melhora da capacidade de enfrentamento ou de superação dos riscos e vulnerabilidades: <b>{{ historico.classificacao_resultados_tres }}</b></td>
								</tr>
								<tr>
									<td>Houve significativo avanço/melhora da capacidade de enfrentamento ou de superação dos riscos e vulnerabilidades, justificando-se o desligamento do acompanhamento sistemático, sem prejuízo da eventual permanência da família ou indivíduo em outros programas, projetos, serviços ou benefícios da Assistência Social: <b>{{ historico.classificacao_resultados_quatro }}</b></td>
								</tr>
							</table>
							<h4 class="text-secondary" v-if="acompanhamento.avaliacoes.length <= 0">
								<i class="mdi mdi-24px mdi-alert-decagram-outline"></i>
								Nenhum histórico registrado.
							</h4>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ["acompanhamento"],
};
</script>